const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-image",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-image1",
    serifid: "iconS-image"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.246,2.358l-16.53,0c-1.483,0 -2.716,1.233 -2.716,2.755l0,13.774c0,1.522 1.233,2.755 2.716,2.755l16.529,-0c1.522,-0 2.755,-1.233 2.755,-2.755l-0,-13.774c0,-1.522 -1.196,-2.755 -2.754,-2.755Zm-14.463,2.755c1.141,-0 2.066,0.925 2.066,2.066c-0,1.141 -0.887,2.066 -2.066,2.066c-1.18,0 -2.067,-0.925 -2.067,-2.066c0,-1.141 0.964,-2.066 2.067,-2.066Zm14.42,13.413c-0.121,0.223 -0.353,0.361 -0.607,0.361l-15.066,0c-0.259,0 -0.496,-0.145 -0.613,-0.377c-0.118,-0.231 -0.096,-0.508 0.057,-0.718l3.013,-4.132c0.13,-0.179 0.337,-0.283 0.556,-0.283c0.22,0 0.427,0.105 0.557,0.283l1.397,1.916l4.016,-5.987c0.13,-0.228 0.345,-0.344 0.573,-0.344c0.228,0 0.445,0.115 0.573,0.307l5.509,8.264c0.142,0.21 0.155,0.481 0.035,0.71Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSImage);
export default __webpack_public_path__ + "static/media/iconS-image.6bbd1697cc4049c0fdda5dd981fb9b93.svg";
export { ForwardRef as ReactComponent };